/* src/app/questionnaire/result/result.component.scss */
.content {
  background-color: #FFFF00;
  color: black;
  font-weight: 200;
}
.content2 {
  background-color: #FFFF00;
  color: black;
  padding: 1em;
}
.question {
  background-color: rgb(235, 47, 47) !important;
}
@media (min-width: 768px) {
  .content {
    font-size: 20px;
  }
  .ion-text-wrap {
    font-size: 20px;
  }
}
/*# sourceMappingURL=result.component.css.map */
